import classNames from "classnames";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import { ChevronRightIcon } from "../../AscIcons";
import AscLink from "../../AscLink/AscLink";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscAccountOptionCard.module.scss";
dayjs.extend(duration);
dayjs.extend(relativeTime);

type AscAccountOptionCardColor =
  | "yellow"
  | "pink-purple"
  | "blue"
  | "lavender"
  | "green"
  | "gray"
  | "light-blue"
  | "purple";

export interface AscAccountOptionCardProps {
  title: string;
  icon: React.ReactNode;
  description: string;
  color?: AscAccountOptionCardColor;
  className?: string;
  path: string;
}

export default function AscAccountOptionCard({
  title,
  description,
  icon,
  path,
  color = "gray",
  className,
}: AscAccountOptionCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, {
        [styles.yellow]: color === "yellow",
        [styles.pinkPurple]: color === "pink-purple",
        [styles.blue]: color === "blue",
        [styles.lavender]: color === "lavender",
        [styles.green]: color === "green",
        [styles.gray]: color === "gray",
        [styles.lightBlue]: color === "light-blue",
        [styles.purple]: color === "purple",
        className,
      })}
      bodyClassName={styles.cardBody}
      title={
        <div className={styles.titleContainer}>
          <div className={styles.titleIcon}>{icon}</div>
          <h5 className={styles.cardTitle}>{title}</h5>
        </div>
      }
      imageClassName={styles.cardImage}
      customImage={
        <AscLink href={path} className={styles.iconContainer}>
          <ChevronRightIcon
            className={styles.chevronIcon}
            data-testid={"asc-skill-card-more-icon"}
          />
        </AscLink>
      }
    >
      <p className={styles.description}>{description}</p>
    </AscGenericCard>
  );
}
